import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Svg } from "../svg/Svg";
export const BulletIcon = React.forwardRef((props, ref) => (_jsx(Svg, { "data-testid": "BulletIcon", ...props, ref: ref, viewBox: "0 0 12 12", children: _jsx("g", { transform: "translate(-1175.000000, -4108.000000)", fill: "currentColor", children: _jsx("circle", { cx: "1181", cy: "4114", r: "6" }) }) })));
BulletIcon.displayName = "BulletIcon";
